export default "__VITE_ASSET__16b47799__"